'use client';

import { createContext, useContext } from 'react';

type Messages = { [k: string]: string | Messages };

// - locale: KR EN JP VI
type Ctx = { locale: string; messages: Messages };

// - 기본값은 null로 두고 Provider에서 실제 값
const I18nCtx = createContext<Ctx | null>(null);


export function I18nProvider({
                               locale,
                               messages,
                               children
                             }: {
  locale: string;
  messages: Messages;
  children: React.ReactNode;
}) {
  return <I18nCtx.Provider value={{ locale, messages }}>{children}</I18nCtx.Provider>;
}

// "GNB.1" → messages.GNB["1"]
// 없으면 key 그대로 출력
const findMessage = (messages: Messages, key: string): string => {
  const parts = key.split('.');
  let cur: unknown = messages;

  for (const p of parts) {
    if (cur && typeof cur === 'object' && p in (cur as Record<string, unknown>)) {
      cur = (cur as Record<string, unknown>)[p];
    } else return key;
  }

  return typeof cur === 'string' ? cur : key;
};

// 컴포넌트에서 const t = useT(); t("GNB.1") 이렇게 사용
export function useT() {
  const ctx = useContext(I18nCtx);
  if (!ctx) return (k: string) => k;
  return (k: string) => findMessage(ctx.messages, k);
}


// - Provider 없으면 기본값 'KR'
export function useCurrentLocale() {
  const ctx = useContext(I18nCtx);
  return ctx?.locale ?? 'KR';
}
